import React from 'react'
import '../../index.css'

///Calculation & parsing functions for Tables
const getSizeEntries = (sizes) => {
    return (
        <>
            {sizes.map(entry =>
                <th className="sizeColumn">{entry.SizeValue}</th>)
            }
        </>
    )
}

const getStringsSizeEntries = (sizeValues) => {
    return (
        <>
            {sizeValues.map(size =>
                <th className="size-value">{size}</th>)
            }
        </>
    )
}

const getSizeNumbers = (sizeEntries) => {
    return (
        <>
            {sizeEntries.map(entry =>
                <td className="numberColumn">{entry.Amount}</td>)
            }
        </>
    )
}

const getCorrectionNumbers = (sizeEntries) => {
    return (
        <>
            {sizeEntries.map(entry =>
                <td className="sizeColumntd">{(entry.CorrectionAmount > 0 ? "+" : "") + entry.CorrectionAmount}</td>)
            }
        </>
    )
}

const getTotal = (sizeEntries) => {
    let numbers = sizeEntries.map(entry => parseInt(entry.Amount))
    let total = 0
    numbers.map(number => total = parseInt(total) + parseInt(number))
    return (
        <>
            <td className="numberColumn">{total}</td>
        </>
    )
}

///Table Components



export { getSizeEntries, getSizeNumbers, getCorrectionNumbers, getTotal, getStringsSizeEntries }